import { ExportStatusEnum } from '@/types/enum/ExportStatusEnum';

export default {
	title: 'AccessMaster',
	selectAllRole: 'Sélectionner tous les rôles',
	labelParamsForm: 'Périmètre (si plusieurs codes, séparer par des points-virgules)',
	actions: {
		apply: 'Appliquer'
	},
	export: {
		status: [
			{
				value: 'Waiting',
				text: ExportStatusEnum.Waiting
			},
			{
				value: 'WorkInProgress',
				text: ExportStatusEnum.WorkInProgress
			},
			{
				value: 'Finalizing',
				text: ExportStatusEnum.Finalizing
			},
			{
				value: 'Archived',
				text: ExportStatusEnum.Archived
			},
			{
				value: 'Error',
				text: ExportStatusEnum.Error
			},
			{
				value: 'Cancelled',
				text: ExportStatusEnum.Cancelled
			}
		],
		types: {
			projectControlFile: 'Fichier de contrôle'
		},
		form: {
			typeLabel: 'Choisir le type d’export à générer',
			typeBtn: 'Valider',
			generateBtn: 'Générer l’export'
		},
		urls: {
			downloadExport: '/api/exports/{exportId}/file',
			cancelExport: '/api/accessmaster/exports/{exportId}/cancel',
			deleteExport: '/api/accessmaster/exports/{exportId}',
			billing_data_third_party: '/api/exports/billing-data-third-party',
			billing_data_manager: '/api/exports/billing-data-manager',
			payments_extraction_async: '/api/exports/payments/async',
			proweb_extraction: '/api/exports/proweb-payments/async',
			proweb_undue_extraction: '/api/exports/proweb-undue-payments/async',
			patient_eds: '/api/exports/eds-patients',
			idel_declarations: '/api/exports/idel-declaration',
			project_users_actors: '/api/exports/project-users-actors',
			project_users: '/api/exports/project-users',
			project_price_codes: '/api/exports/project-price-codes',
			project_control_file: '/api/exports/project-control-file',
			project_functionality: '/api/exports/projects/functionalities',
			imported_files: '/api/exports/imported-files',
			actors: '/api/exports/actors',
			copil_summary: '/api/exports/copil-summary',
			payments_control: '/api/exports/payments-control',
			payment_monitoring_report: '/api/exports/payment-monitoring-report',
			survey_campaign_detailed_report: '/api/survey-campaign/exports/survey-campaign-detailed-report',
			project_survey_campaign_completion_report: '/api/survey-campaign/exports/project-survey-campaign-completion-report',
			survey_campaign_questions_answers_aggregated: '/api/survey-campaign/exports/survey-campaign-questions-answers-aggregated',
			undue_list_extraction: '/api/exports/undues/undue_list_extraction/async',
			undue_list_admin_extraction: '/api/exports/undues/undue_list_admin_extraction/async',
			undue_detailed_list_extraction: '/api/exports/undues/undue_detailed_list_extraction/async'
		}
	},
	payments: {
		actor_warning: 'Le destinataire de versement a été modifié. Son nouvel identifiant est {code}.',
		forcedRecoveryConfirmation: {
			title: {
				one: 'Êtes-vous sûr de vouloir reprendre ce paiement ?',
				multiple: 'Êtes-vous sûr de vouloir reprendre ces {count} paiements ?'
			},
			message: {
				one: 'Cet indu n\'autorise pas la reprise sur flux, confirmez-vous votre choix de le reprendre ?',
				multiple: 'Les indus suivants n\'autorisent pas la reprise sur flux, confirmez-vous votre choix de les reprendre ?'
			},
			confirmBtn: 'Valider ma décision',
			removePaymentTooltip: 'Retirer ce paiement de la liste des reprises forcées'
		},
		RejectConfirmation: {
			title: 'Détails du rejet'
		}
	},
	undues: {
		editUndue: {
			title: 'Modifier l\'indu',
			negativeAmount: {
				title: 'Confirmation montant négatif',
				message: 'Un ou des remboursements ont un montant négatif. Souhaitez-vous confirmer la modification ?'
			},
			noClaimFile: 'Aucune créance déposée'
		},
		deleteUndue: {
			title: 'Supprimer l\'indu'
		},
		recycleUndue: {
			title: 'Recycler l\'indu'
		},
		addRefund: 'Ajouter un remboursement',
		confirmCancelUndue: {
			title: 'Confirmez-vous l\'annulation de cet indu ?',
			confirmBtnText: 'Confirmer l\'annulation'
		},
		confirmRecycleUndue: {
			title: 'Confirmez-vous le recyclage de cet indu ?',
			confirmBtnText: 'Confirmer le recyclage'
		},
		errors: {
			amountPositive: 'Le montant de reprise doit être supérieur à 0.',
			amountInvalidComparedToUndueBalance: 'Le montant de reprise ne peut pas être supérieur au montant du solde des indus.',
			amountInvalidComparedToPaymentAmount: 'Le montant de reprise ne peut pas être supérieur au montant du paiement.'
		}
	}
};
